import React, { Component } from "react";
import { FiCheck } from "react-icons/fi";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../translations";

class FeatureList extends Component {
    static contextType = LanguageContext;

    render() {
        const { language } = this.context;
        const t = translations[language];

        const features = t.homepage.features || [
            {
                title: "FinTech Platforms",
                items: [
                    "Digital banking systems",
                    "Payment gateways & wallets",
                    "Investment & trading platforms",
                    "KYC, AML & compliance-ready systems"
                ]
            },
            {
                title: "Modern Web Development",
                items: [
                    "High-performance web applications",
                    "SaaS platforms",
                    "Enterprise dashboards",
                    "API-first and microservices systems"
                ]
            },
            {
                title: "AI-Driven Development",
                items: [
                    "AI-assisted system architecture",
                    "Intelligent data processing & automation",
                    "Predictive analytics & financial insights",
                    "Smart UX personalization"
                ]
            },
            {
                title: "UI/UX Excellence",
                items: [
                    "User-centric UX research",
                    "Conversion-focused design systems",
                    "Arabic & international market expertise",
                    "Enterprise-grade design consistency"
                ]
            }
        ];

        return (
            <React.Fragment>
                <div className="row">
                    {features.map((feature, index) => (
                        <div className="col-lg-6 col-md-6 col-12 mt--30" key={index}>
                            <div className="feature-box">
                                <h3 className="title">{feature.title}</h3>
                                <ul className="list-style--1">
                                    {feature.items.map((item, i) => (
                                        <li key={i}>
                                            <FiCheck /> {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

export default FeatureList;

